import { render } from "./create_transfert_modal.vue?vue&type=template&id=095860b6"
import script from "./create_transfert_modal.vue?vue&type=script&lang=js"
export * from "./create_transfert_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__